import { usePlaylistStore } from "@/stores/playlist.js";

export function getBrowserInfo() {
    const plStore = usePlaylistStore();
    const ua = navigator.userAgent;

    // Detect Browser name and version
    if (ua.indexOf("Edg") > -1) {
        plStore.setBrowserName("Microsoft Edge");
        plStore.setBrowserVersion(ua.substr(ua.lastIndexOf("Edg/") + 4));
    } else if (ua.indexOf("Chrome") > -1) {
        plStore.setBrowserName("Chrome");
        plStore.setBrowserVersion(
            ua.substr(
                ua.lastIndexOf("Chrome/") + 7,
                ua.lastIndexOf(" Safari") - (ua.lastIndexOf("Chrome/") + 7)
            )
        );
    } else if (ua.indexOf("Safari") > -1) {
        plStore.setBrowserName("Safari");
        plStore.setBrowserVersion(
            ua.substr(
                ua.lastIndexOf("Version/") + 8,
                ua.lastIndexOf(" Safari") - (ua.lastIndexOf("Version/") + 8)
            )
        );
    } else if (ua.indexOf("Firefox") > -1) {
        plStore.setBrowserName("Firefox");
        plStore.setBrowserVersion(ua.substr(ua.lastIndexOf("Firefox/") + 8));
    } else if (ua.indexOf("MSIE") > -1 || ua.indexOf("Trident/") > -1) {
        plStore.setBrowserName("Internet Explorer");
        plStore.setBrowserVersion(
            ua.substr(
                ua.lastIndexOf("MSIE ") + 5,
                ua.lastIndexOf("; Windows") - (ua.lastIndexOf("MSIE ") + 5)
            )
        );
    }
}

export function isMobileDevice() {
    const plStore = usePlaylistStore();
    const mobileKeywords = [
        "Android",
        "iPhone",
        "iPod",
        "BlackBerry",
        "Windows Phone",
        "webOS",
    ];
    plStore.setIsMobileDevice(
        mobileKeywords.some((keyword) => navigator.userAgent.includes(keyword))
    );
}
